import React from "react";
import {ScaleLoader} from "react-spinners";

/**
 * Global app loader — the single source of truth for loader size so every
 * spinner renders at ONE consistent dimension (no more per-call-site width/height
 * drift). The height/width defaults mirror the modal "gate" loader in hopnModal.
 *
 * Only `color` is meant to vary per page (e.g. "#fff" on dark buttons); pass it
 * via the prop. `height`/`width` are overridable too, but should rarely be needed.
 */
export function Loader({color = "#201e20", height = 20, width = 2, ...rest}) {
    return <ScaleLoader color={color} height={height} width={width} {...rest}/>;
}

export default Loader;
